// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"dc7d5310","280":"74b9f464","350":"96103484","473":"66208365","740":"96103484","956":"5212e116"}[chunkId] + ".chunk.css";
};